export class PropertyPhase{
    //id: 10=Pipeline, 20=Engaged, 30=Wind Down, 40=Terminated

    constructor(public id:number, public name:string){
    }

    get color(){
        switch(this.id){
            case 10: return '#0077ff';
            case 20: return '#0fa00194';
            case 30: return '#FFA500';
            case 99: return '#FF0000';
            default: return '#808080';
        }
    }
}